import { toast } from 'react-toastify';
import { DownloadReportsModel } from '../models';

type downloadReport = (
    body: DownloadReportsModel,
    msgLoading: string | undefined,
    msgSuccess: string | undefined,
    msgError: string | undefined,
    msgAlert: string,
    msgFile: string,
    urlAPI: string,
    extension?: string 
) => void;

/**
 * Función genérica para manejar la descarga de reportes.
 * @param reportBody - Cuerpo del reporte con los parámetros necesarios.
 * @param alertMessage - Mensaje de alerta si los parámetros no son válidos.
 * @param reportName - Nombre del reporte para mostrar en el mensaje de alerta.
 * @param endpoint - URL del endpoint para descargar el reporte.
 * @param downloadFn - Función de descarga específica.
 */
export const handleDownloadReport = (
    startDate: string,
    endDate: string,
    employeeIds: number[],
    alertMessage: string,
    reportName: string,
    endpoint: string,
    downloadFn: downloadReport,
    addHourSuffix: boolean = true,
    extension: string = 'xlsx' 
) => {
    if (
        startDate === '' ||
        endDate === '' ||
        !employeeIds ||
        employeeIds.length === 0
    ) {
        toast.error(alertMessage, {
            isLoading: false,
            autoClose: 5000,
            position: toast.POSITION.BOTTOM_RIGHT,
            closeOnClick: true,
            closeButton: true,
        });
        return;
    }

    const reportBody: DownloadReportsModel = {
        startDate: addHourSuffix ? startDate + 'T01:00' : startDate,
        endDate: addHourSuffix ? endDate + 'T01:00' : endDate,
        employeeIds: employeeIds,
    };

    downloadFn(
        reportBody,
        undefined,
        undefined,
        undefined,
        alertMessage,
        reportName,
        endpoint,
        extension 
    );
};
